module.exports = __webpack_public_path__ + "img/3.290362b5.png";